export default __webpack_public_path__ + "static/media/NoDataImg.f8ab02f6.png";